const CRITICAL_FIELDS = ["model_name", "manufacturer", "ehs_price", "dimensions", "sqft"];
const IMPORTANT_FIELDS = ["home_type", "factory_address", "est_factory_cost"];
const MEDIA_FIELDS = ["image_url", "floorplan_image_url"];

function hasValue(value) {
    if (value === null || value === undefined) return false;
    if (typeof value === "number") return Number.isFinite(value) && value > 0;
    return String(value).trim().length > 0;
}

export function hasHomePhoto(home = {}) {
    return ["image_url", "primary_image_url", "exterior_image_url", "photo_url", "image"].some((key) => hasValue(home[key]));
}

export function hasFloorplan(home = {}) {
    return ["floorplan_image_url", "floorplan_url", "floor_plan_url", "plan_image_url"].some((key) => hasValue(home[key]));
}

export function getHomeCatalogCompleteness(home = {}) {
    const criticalMissing = [];
    const importantMissing = [];
    const mediaMissing = [];

    if (!hasValue(home.model_name)) criticalMissing.push("Home name/model");
    if (!hasValue(home.manufacturer)) criticalMissing.push("Manufacturer");
    if (!hasValue(home.ehs_price)) criticalMissing.push("Base home price");
    if (!hasValue(home.dimensions)) criticalMissing.push("Dimensions");
    if (!hasValue(home.sqft)) criticalMissing.push("Square footage");

    if (!hasValue(home.home_type)) importantMissing.push("Home type");
    if (!hasValue(home.factory_address)) importantMissing.push("Factory/origin address");
    if (!hasValue(home.est_factory_cost)) importantMissing.push("Unit factory/internal cost");

    if (!hasHomePhoto(home)) mediaMissing.push("Home image URL");
    if (!hasFloorplan(home)) mediaMissing.push("Floorplan image URL");

    const severity = criticalMissing.length > 0 ? "critical" : (importantMissing.length > 0 || mediaMissing.length > 0 ? "attention" : "complete");

    return {
        severity,
        label: severity === "complete" ? "Complete" : severity === "attention" ? "Needs attention" : "Missing critical data",
        criticalMissing,
        importantMissing,
        mediaMissing,
        allMissing: [...criticalMissing, ...importantMissing, ...mediaMissing],
    };
}

export function getQuoteHomeWarnings(home = {}) {
    const checks = getHomeCatalogCompleteness(home);
    const warnings = [];

    if (checks.criticalMissing.includes("Dimensions")) warnings.push({ level: "critical", text: "Missing dimensions; skirting/perimeter calculations may be incomplete." });
    if (checks.criticalMissing.includes("Square footage")) warnings.push({ level: "critical", text: "Missing square footage; AC tonnage calculation may be incomplete." });
    if (checks.criticalMissing.includes("Manufacturer")) warnings.push({ level: "critical", text: "Missing manufacturer; catalog matching and pricing review may be needed." });
    if (checks.criticalMissing.includes("Base home price")) warnings.push({ level: "critical", text: "Missing base home price; confirm customer-facing base pricing before sending quote." });
    if (checks.importantMissing.includes("Home type")) warnings.push({ level: "important", text: "Missing home type; calculator may require manual override." });
    if (checks.importantMissing.includes("Factory/origin address")) warnings.push({ level: "important", text: "Missing factory/origin address; factory-to-customer delivery may require manual entry." });
    if (checks.mediaMissing.includes("Home image URL")) warnings.push({ level: "media", text: "Missing home image URL; PDF home photo page will use fallback." });
    if (checks.mediaMissing.includes("Floorplan image URL")) warnings.push({ level: "media", text: "Missing floorplan image URL; PDF floorplan page will use fallback." });

    return { ...checks, warnings };
}
